import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, getWorkplaceSetting, getServices } from '../api/client';
import './Login.css';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await login(email, password);

      if (response.success && response.data) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        localStorage.setItem('user', JSON.stringify(response.data.user));

        // Проверяем избранное — редирект если есть
        try {
          const favorites = await getWorkplaceSetting('favorite_tiles');
          const favoriteArray = Array.isArray(favorites) ? favorites : [];
          if (favoriteArray.length > 0) {
            const servicesData = await getServices();
            const favoriteService = servicesData.find((s: any) => s.id === favoriteArray[0]);
            if (favoriteService?.url) {
              if (favoriteService.url.startsWith('http')) {
                window.location.href = favoriteService.url;
                return;
              } else if (favoriteService.url.startsWith('/workplane') || favoriteService.url.startsWith('/pay') || favoriteService.url.startsWith('/stats') || favoriteService.url.startsWith('/adminer') || favoriteService.url.startsWith('/admin')) {
                window.location.href = favoriteService.url;
                return;
              } else {
                navigate(favoriteService.url);
                return;
              }
            }
          }
        } catch (e) {
          // Игнорируем ошибки — редирект на главную
        }

        navigate('/');
      } else {
        setError(response.error?.message || 'Ошибка входа');
      }
    } catch (err: any) {
      setError(err.response?.data?.error?.message || 'Ошибка соединения с сервером');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-logo">
          <h1>КАРБИ</h1>
          <p>Добро пожаловать! Продуктивного дня!</p>
        </div>

        <div className="login-card">
          <h2>Вход в систему</h2>

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="manager@karbi.ru"
                required
              />
            </div>

            <div className="form-group">
              <label>Пароль</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                placeholder="••••••••"
                required
              />
            </div>

            <button type="submit" className="login-button" disabled={loading}>
              {loading ? 'Вход...' : 'Войти'}
            </button>
          </form>
        </div>

        <div className="login-footer">
          <p>© 2026 КАРБИ. Все права защищены.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
